import { render, staticRenderFns } from "./StudentInvoice.vue?vue&type=template&id=144ba06b&scoped=true&"
import script from "./StudentInvoice.vue?vue&type=script&lang=js&"
export * from "./StudentInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144ba06b",
  null
  
)

export default component.exports